import React from 'react';
import {PaypalRequestsLoadingDialog} from './PaypalRequestsLoadingDialog';
import {PaypalRequestsProvider} from '../context/PaypalRequestsContext';
import {PaypalRequestsCard} from './PaypalRequestsCard';

export function PaypalRequestsPage() {

  return (
    <PaypalRequestsProvider>
      <PaypalRequestsLoadingDialog />
      <PaypalRequestsCard />
    </PaypalRequestsProvider>
  );
}
